export const sortMenu = [
    {
        id: 1,
        title: "Latest",
    },
    {
        id: 2,
        title: "Featured",
    },
    {
        id: 3,
        title: "Top Rated",
    },
    {
        id: 4,
        title: "Price(Lowest First)",
    },
    {
        id: 5,
        title: "Price(Highest First)"
    },
];

export const brandsMenu = [
    {
        id: 1,
        label: "JBL",
        checked: false,
    },
    {
        id: 2,
        label: "BoAt",
        checked: false,
    },
    {
        id: 3,
        label: "Sony",
        checked: false,
    },
];

export const categoryMenu = [
    {
        id: 1,
        label: "Headphones",
        checked: false,
    },
    {
        id: 2,
        label: "Earbuds",
        checked: false,
    },
    {
        id: 3,
        label: "Earphones",
        checked: false,
    },
    {
        id: 4,
        label: "Neckbands",
        checked: false,
    },
];
